// extracted by mini-css-extract-plugin
export var container = "_mo-0";